import axios from 'axios';
import {
  COLLECTIONS_DELETE_COLLECTION_META_DATA_TABLE_MAPPING_BEGIN,
  COLLECTIONS_DELETE_COLLECTION_META_DATA_TABLE_MAPPING_SUCCESS,
  COLLECTIONS_DELETE_COLLECTION_META_DATA_TABLE_MAPPING_FAILURE,
  COLLECTIONS_DELETE_COLLECTION_META_DATA_TABLE_MAPPING_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function deleteCollectionMetaDataTableMapping(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_DELETE_COLLECTION_META_DATA_TABLE_MAPPING_BEGIN,
    });
    const { projectId, version, mappingId, selectedCollection } = args;
    const { uuid: collectionUuid } = selectedCollection;
    const header = builderSurfaceJsonContentHeader(projectId);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/meta-data-mapping/${collectionUuid}/collection/${mappingId}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_DELETE_COLLECTION_META_DATA_TABLE_MAPPING_SUCCESS,
            data: res.data,
          });
          Mixpanel.track('Deleted Meta Data Mapping in Collection');
          toast.success('Deleted Successfully !');
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_DELETE_COLLECTION_META_DATA_TABLE_MAPPING_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to delete meta data mapping in collection');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteCollectionMetaDataTableMappingError() {
  return {
    type: COLLECTIONS_DELETE_COLLECTION_META_DATA_TABLE_MAPPING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_DELETE_COLLECTION_META_DATA_TABLE_MAPPING_BEGIN:
      return {
        ...state,
        deleteCollectionMetaDataTableMappingPending: true,
        deleteCollectionMetaDataTableMappingError: null,
      };

    case COLLECTIONS_DELETE_COLLECTION_META_DATA_TABLE_MAPPING_SUCCESS:
      return {
        ...state,
        deleteCollectionMetaDataTableMappingPending: false,
        deleteCollectionMetaDataTableMappingError: null,
        metaDataTableMappings: action.data || [],
      };

    case COLLECTIONS_DELETE_COLLECTION_META_DATA_TABLE_MAPPING_FAILURE:
      return {
        ...state,
        deleteCollectionMetaDataTableMappingPending: false,
        deleteCollectionMetaDataTableMappingError: action.data.error,
      };

    case COLLECTIONS_DELETE_COLLECTION_META_DATA_TABLE_MAPPING_DISMISS_ERROR:
      return {
        ...state,
        deleteCollectionMetaDataTableMappingError: null,
      };

    default:
      return state;
  }
}
